/*
  Prismatch-modal — logik
  Åbner modalen ved at kalde jeres modal-dialog-komponents egen .show()-metode,
  HVER gang kunden kopierer teksten i produkttitlen (Ctrl+C / højreklik-kopiér).

  Kræver:
  - Produkttitel-elementet har attributten data-price-match-trigger
  - modal-dialog.js er loadet på siden (den definerer <modal-dialog>-elementet)
*/
(function () {
  const MODAL_ID = 'PriceMatchModal';

  function selectionIsInsideTitle() {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return false;
    const titleEl = document.querySelector('[data-price-match-trigger]');
    if (!titleEl) return false;
    const anchorNode = selection.anchorNode;
    return !!anchorNode && titleEl.contains(anchorNode);
  }

  document.addEventListener('copy', function () {
    if (!selectionIsInsideTitle()) return;

    const modal = document.getElementById(MODAL_ID);
    if (!modal || typeof modal.show !== 'function') return;

    modal.show();
  });
})();
